<div class="dx-navigator">
  <div class="dx-navigator__head">
    <ng-container *ngIf="isHeadMenuShown">
      <dx-head-navigation-menu [options]="options.headNavigationMenuOptions"
                               [menuData]="headMenuItems"
                               (homeClick)="onHomeClick()"
                               (openMenuItem)="onOpenMenuItem($event)"
                               (openSubMenu)="onOpenSubMenu($event)">
      </dx-head-navigation-menu>
    </ng-container>
  </div>

  <div class="dx-navigator__body">

    <div class="dx-navigator__side-panel" *ngIf="isSideMenuShown">
      <dx-side-navigation-menu [options]="options.sideNavigationMenuOptions"
                               [menuData]="sideMenuItems"
                               (openMenuItem)="onOpenMenuItem($event)">
      </dx-side-navigation-menu>
    </div>

    <div class="dx-navigator__content-area">
      <ng-container *ngIf="roueNotFoundMessage">
        <dx-route-not-found [message]="roueNotFoundMessage"></dx-route-not-found>
      </ng-container>
      <router-outlet></router-outlet>
    </div>

  </div>

</div>
